// removed by extract-text-webpack-plugin
module.exports = {"contact":"Contact__contact__1NGbi","contactBg":"Contact__contactBg__3vIpP","contactFormContainer":"Contact__contactFormContainer__1FBtl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Contact/Contact.css
// module id = 305
// module chunks = 0